import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { IApiClient } from 'api/api';
import { sessionReducer } from '@myRedux/session/sessionReducer';
import { userReducer } from '@myRedux/user/userReducer';
import { teacherReducer } from '@myRedux/teacher/teacherReducer';
import { stateReducer } from '@myRedux/state/stateReducer';
import { schoolDistrictReducer } from '@myRedux/schoolDistrict/schoolDistrictReducer';
import { apiReducer } from '@myRedux/api/apiReducer';
import { oauthReducer } from '@myRedux/oauth/oauthReducer';


export const rootReducer = combineReducers({
  api: apiReducer,
  oauth: oauthReducer,
  schoolDistrict: schoolDistrictReducer,
  session: sessionReducer,
  state: stateReducer,
  teacher: teacherReducer,
  user: userReducer
});

export const setupStore = (apiClient: IApiClient, authClient: IApiClient, preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: {
            apiClient: apiClient,
            authClient: authClient
          }
        },
      }),
  })
}

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>
export type AppDispatch = AppStore['dispatch'];